"use strict";
/*
* Created on 20.06.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Resolved secondary placement of particular window item. Instances of this object corresponds to window item
 * and accumulate references to sites with special placement of product of the item.
 * Depending on progress of promotion preparation, the
 * placement is either determined from promotion history or from data from shelf planning (see ProductPlacement).
 * Because of differences between in memory and database representation there is intentionally no schema object and converter
 * implementation have to fill the gap between representations.
 *
 * @author Stepan Mik
 */


var WindowItemPlacement =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemPlacement, _DomainObject_1$Domai);

  function WindowItemPlacement(id, windowItemId, placements) {
    var _this;

    _classCallCheck(this, WindowItemPlacement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPlacement).call(this));
    _this.id = id;
    _this.windowItemId = windowItemId;
    _this.placements = placements;
    return _this;
  }

  _createClass(WindowItemPlacement, [{
    key: "isPlacedIn",
    value: function isPlacedIn(siteId) {
      return this.placements.valueSeq().some(function (s) {
        return s.contains(siteId);
      });
    }
  }], [{
    key: "empty",
    value: function empty(winId) {
      return new WindowItemPlacement(winId, winId, immutable_1.Map());
    }
  }]);

  return WindowItemPlacement;
}(DomainObject_1.DomainObject);

exports.WindowItemPlacement = WindowItemPlacement;